//File utils for glycan visualizer

/**
 * Handles download of svg canvas image.
 * @param {*} svgRef 
 * @param {*} filename 
 */
export function exportSVG(svgRef, filename)
{
    const svgContainer = svgRef.current;
    if (svgContainer){
      const svg = svgContainer.querySelector('svg');
      const svgData = new XMLSerializer().serializeToString(svg);
      const blob = new Blob([svgData], {type: 'image/svg+xml;charset=utf-8'});
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename + '.svg';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
}

/**
 * Handles download of png canvas image.
 * @param {*} pngPreview 
 * @param {*} filename 
 */
export function exportPNG(pngPreview, filename)
{
    const downloadLink = document.createElement('a');
    downloadLink.href = pngPreview;
    downloadLink.download = filename + '.png';
    downloadLink.click();
    downloadLink.remove();
}

/**
 * Handles download of project file (sga).
 * @param {*} content 
 * @param {*} filename 
 */
export function exportProject(content, filename)
{
  const blob = new Blob([JSON.stringify(content)], {type: 'application/json'});
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download =  filename + '.sga';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
